export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const TOGGLE_FILTER_ITEM = 'TOGGLE_FILTER_ITEM';
export const SET_FILTER = 'SET_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';